/**
 * Badge — compact status label with a semantic variant.
 *
 * Used for media status, sync state, and member roles. Purely presentational;
 * the accessible name comes from the `label` prop.
 */
import styles from './Badge.module.css';

export type BadgeVariant = 'ok' | 'warn' | 'error' | 'info' | 'neutral';

export interface BadgeProps {
  /** Visual intent. */
  variant?: BadgeVariant;
  /** Text content (also the accessible name). */
  label: string;
  /** Optional extra class. */
  className?: string;
}

const VARIANT_CLASS: Record<BadgeVariant, string> = {
  ok: styles.ok ?? '',
  warn: styles.warn ?? '',
  error: styles.error ?? '',
  info: styles.info ?? '',
  neutral: styles.neutral ?? '',
};

/** Render a small pill-shaped status badge. */
export function Badge({ variant = 'neutral', label, className }: BadgeProps) {
  const classes = [styles.badge ?? '', VARIANT_CLASS[variant], className ?? '']
    .filter(Boolean)
    .join(' ');
  return (
    <span className={classes} role="status">
      {label}
    </span>
  );
}
